var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"decrease-icon",attrs:{"viewBox":"0 0 15 15","width":_vm.size,"height":_vm.size}},[_c('path',{attrs:{"d":"M2 8.9h4.1V13h-1v-2.3L.8 15l-.8-.8 4.3-4.3H2zM14.2 0l.8.8-4.3 4.3H13v1H8.9V2h1v2.3z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }